module.exports = __webpack_public_path__ + "files/80bdb9aedfd737d2252357285dbd9da0.png";